module.exports = __webpack_public_path__ + "static/img/chanping13.2ec6e9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/yszq/chanping13.jpg
// module id = Af0t
// module chunks = 0